import { Check } from "@mui/icons-material";
import { Chip } from "@mui/material";
import { FC } from "react";
import { Tag } from "types/tag";

type FocusFeedbackChipProps = {
  focus: Tag;
  selectedFocusFeedback: Tag[];
  onUpdate: (data: any) => void;
};

export const FocusFeedbackChip: FC<FocusFeedbackChipProps> = ({
  focus,
  selectedFocusFeedback,
  onUpdate,
}) => {
  const isSelected = selectedFocusFeedback.includes(focus);
  const handleSelectFocusFeedback = () => {
    if (isSelected) {
      onUpdate(
        selectedFocusFeedback.filter((f: Tag) => f.tag_id !== focus.tag_id),
      );
    } else {
      onUpdate([...selectedFocusFeedback, focus]);
    }
  };

  return (
    <Chip
      sx={{ mr: 1, mb: 1 }}
      icon={isSelected ? <Check /> : undefined}
      label={focus.name}
      color={isSelected ? "success" : "primary"}
      variant={isSelected ? "filled" : "outlined"}
      onClick={handleSelectFocusFeedback}
    />
  );
};
